






























import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
    components: {}
})
export default class EuropeFlag extends Vue {
    @Prop() heightSize!: string | null;
    @Prop() widthSize!: string | null;

    private sizeStyle = {
        width: this.widthSize ? this.widthSize : "auto",
        height: this.heightSize ? this.heightSize : "auto",
        position: "relative"
    };
}
